export interface StrategyRule {
  id: string
  label: string
  title: string
  meta: string
  description: string
}

export const strategyRules: StrategyRule[] = [
  {
    id: '01',
    label: 'Rule 01',
    title: 'El Rango',
    meta: '15M',
    description:
      'Marcamos el campo de batalla institucional. El rango de apertura define dónde se posiciona el dinero grande antes de cualquier movimiento.',
  },
  {
    id: '02',
    label: 'Rule 02',
    title: 'El Gatillo',
    meta: '1M',
    description:
      'Esperamos la ruptura sólida y el retroceso técnico. Sin retroceso confirmado, no hay entrada: la paciencia es parte del sistema.',
  },
  {
    id: '03',
    label: 'Rule 03',
    title: 'Gestión 1:2',
    meta: 'R:R',
    description:
      'Stop Loss fijo de 5 pips y objetivo al doble del riesgo. Matemática diseñada para Fondos de Inversión, no para la intuición.',
  },
]

export interface Partner {
  name: string
  category: string
  note: string
  href: string
}

/** Cuentas recomendadas para ejecutar el protocolo (enlaces de afiliado). */
export const partners: Partner[] = [
  {
    name: 'Elyon Markets',
    category: 'Broker',
    note: 'Spreads bajos en XAU/USD',
    href: 'https://portal.elyonmarkets.com/client/register/69e28bf7dd1bb',
  },
  {
    name: 'Sure Leverage Funding',
    category: 'Fondeo',
    note: 'Evaluación con drawdown controlado',
    href: 'https://sureleveragefunding.com/?ref=SAMUELMARQUEZ22-JWFKHN',
  },
  {
    name: 'Bybit',
    category: 'Cripto',
    note: 'Spot y derivados 24/7',
    href: 'https://www.bybit.com/invite?ref=ELXZXNV&medium=referral&utm_campaign=evergreen&share_to=link',
  },
]

export const offerIncludes: string[] = [
  'Manual PDF — Protocolo de Apertura VIP',
  'Calculadora de Riesgo (lotaje y 5 pips)',
  'Checklist de Sesión pre-mercado',
]
